const Button = ({buttonClasses, children, ...rest}) => {
  return (
    <button className={`button ${buttonClasses}`} {...rest}>
      {children}
    </button>
  );
};

export default Button;
